import React, { useState } from 'react'
import classNames from 'classnames'
import Icon from 'meinian-package/src/component/icon'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import { NewElement } from './element'
import styles from './index.module.less'

export default ({ currentImage, boxIndex, onBoxIndex }) => {
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false)

  const onFeedback = () => {
    setFeedbackModalVisible(true)
  }

  return <div className={classNames(styles.infoBlock, 'mt32')}>
    <div className={styles.titleLine}>
      <div className={styles.point} />
      <div className={styles.mainTitle}>
        智能标签
        <Tooltip placement="bottom" style={{ color: '#fff', width: '160px' }} title="基于知衣独家图像识别模型生成服饰类标签">
          <Icon type="m-bangzhu_miaobian" style={{ color: 'var(--m-text-3)', marginLeft: '8px' }} />
        </Tooltip>
      </div>
      <div className={styles['header-right']}>
        <div className={styles['header-right-text-1']}>识别有误？</div>
        <div className={classNames(styles['header-right-text-2'], 'fill-white-bg')} onClick={() => onFeedback()}>
          <Icon type="m-bianji" className={styles['header-right-icon-1']} />
          提交反馈
        </div>
      </div>
    </div>
    <div className={styles.infoBlockContext}>
      <NewElement
        currentImage={currentImage}
        boxIndex={boxIndex}
        setBoxIndex={onBoxIndex}
        hiddenTip
        feedbackModalVisible={feedbackModalVisible}
        setFeedbackModalVisible={setFeedbackModalVisible}
      />
    </div>
  </div>
}
